import { createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  typography: {
    fontFamily: ["Ubuntu Condensed", "sans-serif"].join(","),
    fontSize: 15,
  },
  palette: {
    type: "dark",
    primary: {
      main: "#b2ebf2",
      contrastText: "#000",
    },
    secondary: {
      main: "#b2dfdb",
      light: "#c1e5e2",
      contrastText: "#000",
    },
    background: {
      paper: "rgba(0, 0, 0, 0.5)",
      card: "rgba(0, 0, 0, 0.5)"
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      phone: 700,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  overrides: {
    // Cards keep the translucent paper; floating layers need a solid
    // background so text and buttons stay readable over the page.
    MuiDialog: {
      paper: {
        backgroundColor: "#192231",
        backgroundImage: "none",
      },
    },
    MuiPopover: {
      paper: {
        backgroundColor: "#192231",
      },
    },
    MuiCssBaseline: {
      "@global": {
        "html, body, #root": {
          width: "100%",
          minHeight: "100%",
          overflowX: "hidden",
        },
        "*, *::before, *::after": {
          boxSizing: "border-box",
        },
        body: {
          margin: 0,
          background: "linear-gradient(170deg, #192231 70%, #B6A19E 10%)",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed",
        },
        img: {
          maxWidth: "100%",
          height: "auto",
        },
      },
    },
  },
});

export default theme;
